import React from "react";

const TutorPayrollHeader = ({ yearMonth, tutorName, tutorEmail, formatMonth, navigate }) => {
  const styles = {
    header: {
      marginBottom: "2rem",
    },
    titleRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      marginBottom: "0.5rem",
    },
    title: {
      fontSize: "2rem",
      fontWeight: "700",
      color: "#001272",
      margin: "0",
    },
    subtitle: {
      color: "#001272",
      opacity: "0.8",
      fontSize: "1rem",
      margin: "0.25rem 0 0 0",
    },
    backButton: {
      backgroundColor: "transparent",
      color: "#001272",
      border: "1px solid #001272",
      borderRadius: "0.375rem",
      padding: "0.5rem 1rem",
      fontWeight: "500",
      cursor: "pointer",
      transition: "all 0.2s",
    },
    backButtonHover: {
      backgroundColor: "#001272",
      color: "white",
    },
  };

  return (
    <div style={styles.header}>
      <div style={styles.titleRow}>
        <div>
          <h1 style={styles.title}>
            {tutorName || "Tutor"} - {formatMonth(yearMonth)}
          </h1>
          <p style={styles.subtitle}>
            {tutorEmail ? `Email: ${tutorEmail}` : "Payroll details for this tutor"}
          </p>
        </div>
        <button
          style={styles.backButton}
          onClick={() => navigate(-1)}
          onMouseEnter={(e) => {
            Object.assign(e.currentTarget.style, styles.backButtonHover);
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "transparent";
            e.currentTarget.style.color = "#001272";
          }}
        >
          ← Back
        </button>
      </div>
    </div>
  );
};

export default TutorPayrollHeader;
